const initialCheckedState = {
  morning: false,
  afternoon: false,
  evening: false,
  selected: false,
}

const initialStateAvailability = {
  sunday: initialCheckedState,
  monday: initialCheckedState,
  tuesday: initialCheckedState,
  wednesday: initialCheckedState,
  thursday: initialCheckedState,
  friday: initialCheckedState,
  saturday: initialCheckedState,
}

const initialState = {
  locations: [],
  specialties: [],
  availability: initialStateAvailability,
}

export default initialState
